import React  from 'react';

import ListComponentProto from "./rating-proto";

export default function renderRatingGroupTListHeader1(id, props) {
    const notSet = _.isNil(props.data.value);

    return (
        <React.Fragment>
            {!notSet && <ListComponentProto renderMode="t-list" id={id} canEdit={false} value={props.data.value}/>}
            {notSet && <div className="ui5-txt-default text">Not set</div>}
        </React.Fragment>
    );
}